<script>
import { donationCurrencySymbol } from '@/constants/currencies.js'
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'
import TwNotification from '@/components/generic/notification/tw-notification.vue'
import TwModal from '@/components/generic/modal/tw-modal.vue'
import modalCascadeMixin from '@/mixins/modalCascadeMixin.js'
import TwButton from '@/components/generic/tw-button.vue'
import TwNumber from '@/components/generic/forms/tw-number.vue'

export default {
  name: 'DonationAppFeeChangeModal' ,
  components: { TwNumber, TwButton, TwModal, TwNotification, TwTransitionContainer },
  mixins: [modalCascadeMixin],
  props:{
    modelValue: {
      type: [Number],
      default: null
    },
    currency: {
      type: String,
      default: 'USD'
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      ShowAppFeeEditor: false,
    }
  },
  computed: {
    currencySymbol() {
      return donationCurrencySymbol(this.currency)
    }
  },
  methods: {
    saveAndClose() {
      this.close()
    }
  }
}
</script>

<template>
  <tw-modal ref="modal" no-footer title="We’re passionate about helping nonprofits raise more money for less. That’s why GroupRev is 100% free for them to use—no platform fees, ever." size="sm" ok-text="Sounds Good">
    <div class="text-sm grid gap-4 text-gray-900">
      <div class="flex flex-col gap-4">
        <p> This is only possible because generous donors like you choose to add a small contribution to help cover the real costs (servers, security, and software improvements). Our suggested contribution is about half of what other platforms charge, and every contribution keeps fundraising accessible to all.</p>
        <p> If you’d prefer not to contribute, you can remove it and still support this fundraiser. </p>
      </div>
      <tw-transition-container>
        <div v-if="ShowAppFeeEditor" class="mt-4">
          <div> <tw-number :model-value="modelValue" label="Optional Contribution Amount" :prepend="currencySymbol" @keyup.enter="saveAndClose" @update:model-value="$emit('update:modelValue', $event)" /> </div>
          <div class="pt-8 flex flex-row justify-end gap-3">
            <div>
              <tw-button variant="secondary" class="grow" @click="close()">
                Cancel
              </tw-button>
            </div>
            <div>
              <tw-button variant="amber" class="w-full sm:w-auto" @click="saveAndClose">
                Save
              </tw-button>
            </div>
          </div>
        </div>
        <div v-else class="flex flex-row flex-wrap justify-end gap-3 mt-4">
          <tw-button variant="amber" block class="w-full sm:w-auto" @click="close()">
            Sounds Good
          </tw-button>
          <tw-button variant="secondary" block class="w-full sm:w-auto" @click="ShowAppFeeEditor = true">
            Change Optional Amount
          </tw-button>
        </div>
      </tw-transition-container>
    </div>
    <tw-notification>
      <div class="text-center">
        <p> Optional contribution saved! </p>
      </div>
    </tw-notification>
  </tw-modal>
</template>

<style scoped>

</style>
